"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var extend_1 = tslib_1.__importDefault(require("extend"));
var TrackerUtil_1 = tslib_1.__importDefault(require("./TrackerUtil"));
var BasicTrackerAbstractImpl_1 = tslib_1.__importDefault(require("./BasicTrackerAbstractImpl"));
var FacebookPixel = /** @class */ (function (_super) {
    tslib_1.__extends(FacebookPixel, _super);
    function FacebookPixel(options) {
        var _this = _super.call(this, options) || this;
        _this.platformName = FacebookPixel.platformName;
        // Log information
        _this.getLogger().debug("FacebookPixel instance initialized.", "Options: ", options);
        return _this;
    }
    /**
     * @public
     */
    FacebookPixel.getInstance = function (options) {
        options = extend_1.default(true, {}, FacebookPixel.defaultOptions, options);
        var tracker = TrackerUtil_1.default.getInstance(options, FacebookPixel.instances, function (options) {
            return new FacebookPixel(options);
        });
        return tracker;
    };
    /**
     * Facebook has a standard event called "Pageview", but unfortantly they do not let us modify the URL it reports.
     * Because of this we track pageviews that are reported to Google Ads and Microsoft as a custom event called "CustomPageview"
     * This way we can setup custom conversions in Facebook based on this data.
     * We report properties pagePath and pageTitle (optionally).
     * We also record the last reported pagePath and add it as a property to all custom events.
     */
    FacebookPixel.prototype.trackPageview = function (pagePath, title) {
        var action = "CustomPageview";
        this.lastTrackedPagePath = pagePath;
        var properties = {
            pagePath: pagePath
        };
        if (title !== undefined && title !== null) {
            properties.pageTitle = title;
        }
        this._track("FacebookPixel.trackPageview:", action, true, properties);
    };
    /**
     * Track a custom event in Facebook.
     * The `nonInteraction` argument is not used.
     */
    FacebookPixel.prototype.trackEvent = function (category, action, label, value, nonInteraction) {
        var fieldsObject = {
            event_category: category
        };
        action = TrackerUtil_1.default.eventActionToString(action);
        if (label !== undefined && label !== null) {
            fieldsObject.event_label = TrackerUtil_1.default.eventLabelToString(label);
        }
        if (value !== undefined && value !== null) {
            fieldsObject.value = value;
            this.defaultCurrency(fieldsObject);
        }
        if (nonInteraction !== undefined && nonInteraction !== null) {
            // Note: This does not really do anything except record it in Facebook Pixel.
            fieldsObject.nonInteraction = value;
        }
        this._track("FacebookPixel.trackEvent:", action, true, fieldsObject);
    };
    /**
     * See "Lead" on: https://developers.facebook.com/docs/facebook-pixel/reference
     */
    FacebookPixel.prototype.trackEventLead = function (properties) {
        this._track("FacebookPixel.trackEventLead:", "Lead", false, properties);
    };
    /**
     * Consider using `trackEventLead()` if there is a value to this contact.
     * See "Contact" on: https://developers.facebook.com/docs/facebook-pixel/reference
     */
    FacebookPixel.prototype.trackEventContact = function () {
        this._track("FacebookPixel.trackEventContact:", "Contact", false);
    };
    /**
     * See "Schedule" on: https://developers.facebook.com/docs/facebook-pixel/reference
     */
    FacebookPixel.prototype.trackEventSchedule = function () {
        this._track("FacebookPixel.trackEventSchedule:", "Schedule", false);
    };
    /**
     * See "CompleteRegistration" on: https://developers.facebook.com/docs/facebook-pixel/reference
     */
    FacebookPixel.prototype.trackEventCompleteRegistration = function (properties) {
        this._track("FacebookPixel.trackEventCompleteRegistration:", "CompleteRegistration", true, properties);
    };
    /**
     * See "Search" on: https://developers.facebook.com/docs/facebook-pixel/reference
     */
    FacebookPixel.prototype.trackEventSearch = function (properties) {
        this._track("FacebookPixel.trackEventSearch:", "Search", true, properties);
    };
    /**
     * See "AddToCart" on: https://developers.facebook.com/docs/facebook-pixel/reference
     */
    FacebookPixel.prototype.trackEventAddToCart = function (properties) {
        this._track("FacebookPixel.trackAddToCart:", "AddToCart", true, properties);
    };
    /**
     * See "Purchase" on: https://developers.facebook.com/docs/facebook-pixel/reference
     */
    FacebookPixel.prototype.trackEventPurchase = function (properties) {
        this._track("FacebookPixel.trackPurchase:", "Purchase", true, properties);
    };
    /**
     * See "ViewContent" on: https://developers.facebook.com/docs/facebook-pixel/reference
     */
    FacebookPixel.prototype.trackEventViewContent = function (properties) {
        this._track("FacebookPixel.trackEventViewContent:", "ViewContent", true, properties);
    };
    FacebookPixel.prototype._track = function (methodForLogging, eventName, isCustomEvent, properties) {
        if (properties === undefined) {
            properties = {};
        }
        var fbq = this.getPlatformInstance();
        var fbPixelId = this.getTrackerName();
        this.defaultCurrency(properties);
        if (properties.pagePath === undefined
            && this.lastTrackedPagePath !== undefined && this.lastTrackedPagePath !== null) {
            properties.pagePath = this.lastTrackedPagePath;
        }
        if (fbPixelId !== null) {
            fbq(isCustomEvent ? "trackSingleCustom" : "trackSingle", fbPixelId, eventName, properties);
        }
        else {
            fbq(isCustomEvent ? "trackCustom" : "track", eventName, properties);
        }
        // Log
        this.getLogger().debug(methodForLogging, "Event Name / Action:", eventName, "Properties:", properties);
    };
    FacebookPixel.prototype.defaultCurrency = function (properties) {
        if (properties !== undefined && properties.value !== undefined && properties.currency === undefined) {
            properties.currency = "USD";
        }
    };
    FacebookPixel.platformName = "FacebookPixel";
    FacebookPixel.instances = new Map();
    FacebookPixel.defaultOptions = {
        globalKeyForPlatform: "fbq"
    };
    return FacebookPixel;
}(BasicTrackerAbstractImpl_1.default));
exports.default = FacebookPixel;
